var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroSectionRightTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1325,
    height: 858,
    viewBox: "0 0 1325 858",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.342896,
    y: -19.3404,
    width: 628.007,
    height: 1753.92,
    transform: "rotate(-60 0.342896 -19.3404)",
    fill: "url(#paint0_linear_304:2138)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304:2138",
    x1: 314.346,
    y1: -19.3404,
    x2: 314.346,
    y2: 1734.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11B7B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSectionRightTriangle);
export default __webpack_public_path__ + "static/media/hero-section-right-triangle.de683c1a.svg";
export { ForwardRef as ReactComponent };